import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { BASE_URL } from './Config/Config';

function Ctaarea() {

const [Cta , setCta] = useState([])

  useEffect(() => {
    const GetData = async () => {
      try {
        const response = await fetch('https://api.auratechacademy.com/Promo_Banner/');
        const result = await response.json();
        if (result && result.data && result.data.length > 0) {
          setCta(result.data); // full array
        }
      } catch (error) {
        console.error('Error fetching CTA data:', error);
      }
    };

    GetData();
  }, []);


  return (
    <>

    {
      Cta.map((curitm , index)=>(
     
     <div className="cta-area-1" key={index}
      style={{ backgroundImage: `url(/assets/img/bg/cta-bg1.png)` }}
            >
  <div className="container">
    <div className="row align-items-center justify-content-between">
      <div className="col-lg-8">
        <div className="cta-wrap title-area mb-0">
          <div className="cta-icon">
            <img src="/assets/img/normal/cta-icon1.png" alt="icon" />
          </div>
          <div className="cta-content">
            <h2 className="cta-title sec-title">{curitm.title}</h2>
            <p className="cta-text">{curitm.subtitle}</p>
            {/* <p className="cta-text">Your Future Begins Here – Learn, Grow, and Excel with Auratech Academy.</p> */}
          </div>
          <NavLink to="/contact"className="th-btn style8">{curitm.button_text}<i className="fas fa-arrow-right ms-1" /></NavLink>
        </div>
      </div>
    </div>
  </div>

  <div className="cta-img-1" data-overlay="title" data-opacity={4}>

{
  !curitm.video ? (
    <>
    <img src={ curitm.background_image ? ` ${BASE_URL}${curitm.background_image}` :'/assets/img/Get_online_course.jpg'} alt="Image" />
    <NavLink to={curitm.button_link} className="play-btn style2 popup-video"><i className="fa-sharp fa-solid fa-play" /></NavLink>
</>
  ) : (
<>
<video
  src={ curitm.video ? `${BASE_URL}${curitm.background_image}` :'/assets/img/Get_online_course.jpg'}
  controls
  autoPlay
  muted
  loop
  style={{ width: "100%", height: "auto" }}
  alt="auartech ads"
>
  <a href={curitm.video} className="play-btn style2 popup-video" ><i className="fa-sharp fa-solid fa-play" /></a>
  Your browser does not support the video tag.
</video>


</>
  )
}
    
  </div>
</div>
     ))
     } 

    </>
  )
}

export default Ctaarea
